import { render, staticRenderFns } from "./LibraryManagement.vue?vue&type=template&id=4ee6bd60&scoped=true&"
import script from "./LibraryManagement.vue?vue&type=script&lang=ts&"
export * from "./LibraryManagement.vue?vue&type=script&lang=ts&"
import style0 from "./LibraryManagement.vue?vue&type=style&index=0&id=4ee6bd60&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6bd60",
  null
  
)

export default component.exports